import React, { useState } from 'react';

import { DatePicker } from 'antd';
import { RangePickerProps } from 'antd/es/date-picker';
import dayjs, { Dayjs } from 'dayjs';
import styled from 'styled-components';

import { SnapshotDataType } from 'types/snapshot';

import { useSnapshotEditorContext } from './SnapshotEditorContext';
import { US_DATE_FORMAT } from '../../../constants';
import { useSnapshotContext } from '../SnapshotContext';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  padding-bottom: 20px;
`;

const Label = styled.div`
  line-height: normal;
  margin-right: 12px;
  color: var(--text-primary);
`;

const SnapshotEditorModalSelectionItemDate = () => {
  const { currentSnapshot, historicalSnapshots } = useSnapshotContext();
  const { setDate } = useSnapshotEditorContext();
  const [selectedDate, setSelectedDate] = useState<Dayjs>(
    dayjs(currentSnapshot?.date).subtract(1, 'day').hour(12).minute(0).second(0).millisecond(0)
  );
  const handleDateChange = (date: Dayjs) => {
    if (date) {
      // Set the time to the middle of the day (12:00 PM)
      const dateMiddleDay = dayjs(date).hour(12).minute(0).second(0).millisecond(0);
      setDate(dateMiddleDay);
      setSelectedDate(dateMiddleDay);
    }
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    const disabledDates = [currentSnapshot, ...(historicalSnapshots ?? [])].map((item: SnapshotDataType | undefined) =>
      dayjs(item?.date)
    );
    // Can not select days already present in the Snapshots
    return current && disabledDates.some((date) => current.isSame(date, 'day'));
  };

  return (
    <Container>
      <Label>Date</Label>
      <DatePicker
        value={selectedDate}
        size={'small'}
        onChange={handleDateChange}
        style={{
          borderRadius: 0,
          borderColor: 'var(--line-gray)',
          color: 'var(--text-primary)',
          padding: '7px 10px 5px 10px',
          backgroundColor: 'var(--background)',
          lineHeight: 'normal',
          width: 135,
        }}
        allowClear={false}
        maxDate={dayjs(currentSnapshot?.date).subtract(1, 'day')}
        format={US_DATE_FORMAT}
        disabledDate={disabledDate}
        suffixIcon={false}
      />
    </Container>
  );
};

export default SnapshotEditorModalSelectionItemDate;
